module.exports = __webpack_public_path__ + "img/w3_minimize_list_white.1a7026f0.png";